import { Blocks } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const BlocksIcon = createLucideIcon(Blocks);
